let registered = 0

function prevent(register) {
  registered += register ? 1 : -1

  if (registered > 1 || (!register && registered === 1)) return

  const action = register ? 'add' : 'remove'

  document.body.classList[action]('body--prevent-scroll')
}

export default {
  methods: {
    $_preventScroll(state) {
      if (!this.isMobile) return
      if (this.preventedScroll === void 0 && state !== true) {
        return
      }

      if (state !== this.preventedScroll) {
        this.preventedScroll = state
        prevent(state)
      }
    }
  }
}
